/* Component Dependencies */
var accessibilityDetailsTemplate = require('templates/accessibilityDetails.hbs');
var accessibilityCategoryAndListTemplate = require('templates/accessibilityCategoryAndList.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'accessibilityDetails',
    template: {
        'accessibilityDetails': accessibilityDetailsTemplate,
        'accessibilityCategoryAndList': accessibilityCategoryAndListTemplate
    }
});